import AxiosClient from "@/utils/api/axiosClient";

const config = window.rs_line;

class AnalyticsApi extends AxiosClient {
  public apiBaseUrl = `${config.base_url}/analytics`;

  public getSummary = async (start_date: string, end_date: string) => {
    const queryParams = {
      start_date,
      end_date,
      action: "summary"
    };
    const response = await this.axiosClient.get<AnalyticResponse>(
      `${this.apiBaseUrl}`,
      {
        params: queryParams
      }
    );

    return response;
  };

  public getTopPerformingLinks = async (
    start_date: string,
    end_date: string,
    last_id: number
  ) => {
    const queryParams = {
      start_date,
      end_date,
      dimension: "commissions",
      last_id,
      action: "top_performers_link"
    };

    const response = await this.axiosClient.get<TopPerformingLinkResponse>(
      `${this.apiBaseUrl}`,
      {
        params: queryParams
      }
    );

    return response;
  };

  public getTopPerformingAdvertisers = async (
    start_date: string,
    end_date: string,
    last_id: number
  ) => {
    const queryParams = {
      start_date,
      end_date,
      dimension: "commissions",
      last_id,
      action: "top_performers_advertisers"
    };

    const response = await this.axiosClient.get<
      TopPerformingAdvertiserResponse
    >(`${this.apiBaseUrl}`, {
      params: queryParams
    });

    return response;
  };

  public getContributorInfo = async () => {
    const queryParams = {
      action: "contributors"
    };

    const response = await this.axiosClient.get<ContributorResponse>(
      `${this.apiBaseUrl}`,
      {
        params: queryParams
      }
    );

    return response.data.account_admin;
  };
}

export default new AnalyticsApi();
